var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 21.049,
    viewBox: "0 0 28 21.049",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1843",
    "data-name": "Group 1843",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M13.992,21.048q-5.582,0-11.165,0A2.691,2.691,0,0,1,0,18.292q0-7.77,0-15.54A2.669,2.669,0,0,1,2.689,0c.095,0,.189,0,.284,0H25.132a2.723,2.723,0,0,1,2.491,1.307A2.421,2.421,0,0,1,28,2.6q0,7.926,0,15.852a2.67,2.67,0,0,1-2.811,2.6q-5.6.005-11.193,0",
    transform: "translate(0 0)",
    fill: "#2a77eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M7.033,3.531a2.691,2.691,0,0,1-.416,1.627,1.605,1.605,0,0,0-.2,1.209c.194,1.471.373,2.944.557,4.416.019.15.041.3.054.45a.893.893,0,0,1-.451.938.916.916,0,0,1-1.038-.092c-.58-.394-1.171-.77-1.746-1.172a.418.418,0,0,0-.557,0c-.575.4-1.166.778-1.746,1.171a.915.915,0,0,1-1.038.088.881.881,0,0,1-.446-.94C.107,10.384.215,9.54.32,8.7Q.5,7.261.685,5.827a.616.616,0,0,0-.13-.422A3.514,3.514,0,1,1,7.033,3.531m-3.519-1.7a1.7,1.7,0,1,0,.012,3.391,1.7,1.7,0,1,0-.012-3.391m1.44,7.379c-.092-.71-.191-1.439-.278-2.17-.018-.15-.084-.172-.2-.135a3.126,3.126,0,0,1-1.9,0c-.143-.045-.205-.005-.215.153-.012.2-.052.392-.077.589-.067.533-.134,1.067-.2,1.6-.007.059-.038.148.045.172.041.012.1-.027.15-.057C2.49,9.235,2.7,9.1,2.9,8.96a.984.984,0,0,1,1.235-.007c.2.141.407.275.614.408.052.034.106.105.175.059s.026-.122.034-.205",
    transform: "translate(16.592 4.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M4.834,0C6.121,0,7.409,0,8.7,0a.9.9,0,0,1,.827,1.37.83.83,0,0,1-.638.423,4.582,4.582,0,0,1-.538.033q-3.522,0-7.044,0A4.267,4.267,0,0,1,.822,1.8.873.873,0,0,1,0,.835.889.889,0,0,1,.914,0C2,0,3.091,0,4.18,0h.653",
    transform: "translate(4.377 11.358)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M4.843,0C6.121,0,7.4,0,8.677,0a.9.9,0,0,1,.969.978.872.872,0,0,1-.68.808,1.986,1.986,0,0,1-.45.047q-3.692,0-7.384,0A1.554,1.554,0,0,1,.6,1.767.9.9,0,0,1,.012.751.923.923,0,0,1,.953,0C2.164,0,3.376,0,4.588,0h.256",
    transform: "translate(4.372 4.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M4.806,1.838c-1.278,0-2.556,0-3.834,0A.9.9,0,0,1,0,.858a.883.883,0,0,1,.653-.8A1.7,1.7,0,0,1,1.132,0L8.516,0a1.9,1.9,0,0,1,.339.025A.89.89,0,0,1,9.64,1.032a.9.9,0,0,1-.915.8c-.558.013-1.117,0-1.676,0H4.806",
    transform: "translate(4.377 14.839)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M3.518,1.831c-.842,0-1.684,0-2.526,0A.9.9,0,0,1,0,.991.865.865,0,0,1,.884.026C1.373-.009,1.867,0,2.359,0Q4.047,0,5.736,0A4.1,4.1,0,0,1,6.217.03a.871.871,0,0,1,.81.95.892.892,0,0,1-.9.847c-.87.01-1.741,0-2.611,0Z",
    transform: "translate(4.377 7.858)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophies);
export default __webpack_public_path__ + "static/media/trophies.464394da448cc5aa300a0a2e5f5e252f.svg";
export { ForwardRef as ReactComponent };